import { IClinique, ICliniqueSoin, ITreatment } from 'components/core/types'
import constants from 'utils/constants'

export default (treatment: ITreatment, personType: number, clinique: IClinique = null) => {
  if (!clinique) {
    return null
  }
  const { soins } = clinique.acf
  if (soins?.length) {
    const currentSoin = soins?.filter((soin: ICliniqueSoin) => soin.id === treatment.id)?.[0]
    if (currentSoin && currentSoin[constants.personTypes[personType]]) {
      return currentSoin[constants.personTypes[personType]]
    }
  }
  return null
}
